'use client'
import { motion } from 'framer-motion'
import { useRef, useEffect, useState } from 'react'

export interface BannerProps {
  background: string
  slogan: string
}

export default function Banner({ background, slogan }: BannerProps) {
  const contentRef = useRef<HTMLDivElement>(null)
  const [contentWidth, setContentWidth] = useState(0)

  useEffect(() => {
    if (contentRef.current) {
      // Measure a single item's width
      const singleItemWidth = contentRef.current.firstElementChild?.clientWidth || 0
      setContentWidth(singleItemWidth)
    }
  }, [slogan])

  // Calculate how many copies we need to fill the screen plus extras for seamless loop
  const itemsNeeded = contentWidth > 0 ? Math.ceil(window.innerWidth / contentWidth) + 2 : 20

  return (
    <div className="h-8 w-full overflow-hidden" style={{ backgroundColor: background }}>
      <motion.div
        ref={contentRef}
        className="flex items-center h-full"
        animate={{
          x: contentWidth ? [0, -contentWidth] : 0,
        }}
        transition={{
          duration: 10,
          ease: 'linear',
          repeat: Infinity,
        }}
      >
        {Array.from({ length: itemsNeeded }).map((_, i) => (
          <p key={i} className="text-sm whitespace-nowrap px-4">
            {slogan}
          </p>
        ))}
      </motion.div>
    </div>
  )
}
